import { AuthGroupProps } from 'interfaces/AuthProps';

export const IdentifyHasAcessModules = (input: AuthGroupProps[]) => {
  const moduleHasAcess = [];
  for (const user of input) {
    if (user.displayName.includes('app.')) {
      const prefix = user.displayName.split('.');
      moduleHasAcess.push(prefix[1]);
    }
  }
  return moduleHasAcess;
};
